/* Bumble Confidential. For Internal Use Only. */
import { useEffect } from 'react';

const SCROLLED_ATTRIBUTE = 'data-header-scrolled';
const SCROLL_THRESHOLD = 8;

/**
 * Sets data-header-scrolled on <body> once the page is scrolled past the
 * threshold, so the (transparent, fixed) header can get a background in CSS
 * (see styles/components/ui-kit-overrides.scss).
 */
export function useHeaderScrolled() {
  useEffect(() => {
    const update = () => {
      document.body.toggleAttribute(SCROLLED_ATTRIBUTE, window.scrollY > SCROLL_THRESHOLD);
    };

    update();
    window.addEventListener('scroll', update, { passive: true });

    return () => {
      window.removeEventListener('scroll', update);
      document.body.removeAttribute(SCROLLED_ATTRIBUTE);
    };
  }, []);
}
